<script>
    import { guidV4 } from "@itslearning/atlas/generate/guid";

    /** @type {'primary'|'secondary'|'standalone'|'primary-standalone'|'secondary-standalone'} */
    export let kind = 'primary';
    /** @type {string} */
    export let href = '#';
    /** @type {string} */
    export let rel = '';
    /** @type {string} */
    export let iconClass = '';
    /** @type {'start'|'end'} */
    export let iconPlacement = 'start';
    /** @type {string} */
    export let target = '_self';
    /** @type {boolean} */
    export let large = false;
    /** @type {string} */
    export let label = null;
    /** @type {string} */
    export let text = undefined;
    /** @type {string} */
    export let description = undefined;
    /** @type {string} */
    export let ping = undefined;
    /** @type {boolean} */
    export let standalone = false;
    /** @type {boolean} */
    export let downloadable = false;
    /** @type {string} */
    export let fileName = null;

    const id = guidV4();

    $: download = downloadable ? fileName || '' : null;

    $: icon =
        kind === 'standalone' && iconClass
            ? 'prom-link--icon ' + iconPlacementClass + iconClass
            : '';

    $: iconPlacementClass =
        iconPlacement === 'start'
            ? 'prom-link--icon-start '
            : 'prom-link--icon-end ';

    if (standalone) {
        kind = 'standalone';
    }

    $: {
        if (iconClass && kind !== 'standalone') {
            console.warn(
                "Icons can only be added to links in 'standalone' mode."
            );
        }

        if (iconClass && !text && !label) {
            console.warn(
                "Links must have discernible text. If it is an icon-only link, use 'label' to add hidden text."
            );
        }
    }
</script>

<a
    class="prom-link prom-link--{kind} {icon}"
    class:prom-link--large={large}
    {href}
    {rel}
    {target}
    {ping}
    {download}
    aria-label={label}
    aria-describedby={description ? id : undefined}
    on:click
>
    <slot />
    {#if text}{text}{/if}
</a>

{#if description}
    <div {id} class="prom-link__description">{description}</div>
{/if}
